import { useState } from "react";
import { Form, Modal } from "react-bootstrap";
import { ContractSearchDropdown } from "./ContractSearchDropdown";
import { SubmitButton, CancelButton } from "../../shared";

export function AddContractModal({
  api,
  payoutRunId,
  onCancel,
  onSubmit,
  isSubmitting = false,
  onError,
}) {
  const [contract, setContract] = useState(null);

  const canSubmit = !!contract && !isSubmitting;

  const handleSubmit = () => {
    if (!canSubmit || !onSubmit) return;
    onSubmit({ contract, agentKey: "all" });
  };

  return (
    <Modal show onHide={onCancel} centered className="commission-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">Add Missing Record</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label className="field-label">Contract</Form.Label>
          <ContractSearchDropdown
            api={api}
            payoutRunId={payoutRunId}
            value={contract}
            onChange={setContract}
            onError={onError}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <CancelButton onClick={onCancel} disabled={isSubmitting} />
        <SubmitButton
          text="Submit"
          color="blue"
          disabled={!canSubmit}
          isSubmitting={isSubmitting}
          onClick={handleSubmit}
        />
      </Modal.Footer>
    </Modal>
  );
}
